export default "__VITE_ASSET__YvWwsGGA__"